import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { readSignupCookie } from '../utils/referralProgram';
import { http } from './http';

var AuthService = /*#__PURE__*/function () {
  function AuthService() {
    _classCallCheck(this, AuthService);
  }

  _createClass(AuthService, [{
    key: "signup",
    value: function () {
      var _signup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return http.post('/auth/signup', payload);

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function signup(_x) {
        return _signup.apply(this, arguments);
      }

      return signup;
    }()
  }, {
    key: "createUser",
    value: function () {
      var _createUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
        var url, signupCookie, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = "/user";

                if (payload.emailConfirmationRedirect) {
                  url = "".concat(url, "?emailConfirmationRedirect=").concat(payload.emailConfirmationRedirect);
                }

                delete payload.emailConfirmationRedirect;
                signupCookie = readSignupCookie();

                if (signupCookie) {
                  payload.referralCodes = signupCookie;
                }

                _context2.next = 7;
                return http.post(url, payload);

              case 7:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function createUser(_x2) {
        return _createUser.apply(this, arguments);
      }

      return createUser;
    }()
  }, {
    key: "resendVerificationEmail",
    value: function () {
      var _resendVerificationEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id, emailConfirmationRedirect) {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return http.post("/user/".concat(id, "/verifications"), {
                  emailConfirmationRedirect: emailConfirmationRedirect
                });

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", result.data);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function resendVerificationEmail(_x3, _x4) {
        return _resendVerificationEmail.apply(this, arguments);
      }

      return resendVerificationEmail;
    }()
  }, {
    key: "verifyToken",
    value: function () {
      var _verifyToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(token) {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return http.get("/user/".concat(token, "/verifications"));

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", result.data);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function verifyToken(_x5) {
        return _verifyToken.apply(this, arguments);
      }

      return verifyToken;
    }()
  }, {
    key: "requestLogin",
    value: function () {
      var _requestLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return http.post('/auth/request', payload);

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", result.data);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function requestLogin(_x6) {
        return _requestLogin.apply(this, arguments);
      }

      return requestLogin;
    }()
  }, {
    key: "loginWithToken",
    value: function () {
      var _loginWithToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(token) {
        var result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return http.post('/auth/verify', {
                  token: token
                });

              case 2:
                result = _context6.sent;
                return _context6.abrupt("return", result.data);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function loginWithToken(_x7) {
        return _loginWithToken.apply(this, arguments);
      }

      return loginWithToken;
    }()
  }, {
    key: "finishSignup",
    value: function () {
      var _finishSignup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return http.put("/user/finish-signup", payload);

              case 2:
                result = _context7.sent;
                return _context7.abrupt("return", result.data);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function finishSignup(_x8) {
        return _finishSignup.apply(this, arguments);
      }

      return finishSignup;
    }()
  }, {
    key: "updateUser",
    value: function () {
      var _updateUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(id, payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return http.put("/user/".concat(id, "/update"), payload);

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", result.data);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function updateUser(_x9, _x10) {
        return _updateUser.apply(this, arguments);
      }

      return updateUser;
    }()
  }, {
    key: "updateUserEmailNotifications",
    value: function () {
      var _updateUserEmailNotifications = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(userId, payload) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return http.put("/user/".concat(userId, "/email-notifications"), payload);

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function updateUserEmailNotifications(_x11, _x12) {
        return _updateUserEmailNotifications.apply(this, arguments);
      }

      return updateUserEmailNotifications;
    }()
  }, {
    key: "updateUserEmailOptions",
    value: function () {
      var _updateUserEmailOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(token, payload) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return http.put("/user/update-email-options/".concat(token), payload);

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function updateUserEmailOptions(_x13, _x14) {
        return _updateUserEmailOptions.apply(this, arguments);
      }

      return updateUserEmailOptions;
    }()
  }, {
    key: "getUser",
    value: function () {
      var _getUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return http.get("/user/".concat(payload));

              case 2:
                result = _context11.sent;
                return _context11.abrupt("return", result.data);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function getUser(_x15) {
        return _getUser.apply(this, arguments);
      }

      return getUser;
    }()
  }, {
    key: "getUserByShareCode",
    value: function () {
      var _getUserByShareCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(shareCode) {
        var result;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return http.get("/user/".concat(shareCode, "/share-code"));

              case 2:
                result = _context12.sent;
                return _context12.abrupt("return", result.data);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function getUserByShareCode(_x16) {
        return _getUserByShareCode.apply(this, arguments);
      }

      return getUserByShareCode;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return http.post("/auth/login", payload);

              case 2:
                result = _context13.sent;
                return _context13.abrupt("return", result.data);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function login(_x17) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return http.post("/auth/reset-password", payload);

              case 2:
                result = _context14.sent;
                return _context14.abrupt("return", result.data);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function resetPassword(_x18) {
        return _resetPassword.apply(this, arguments);
      }

      return resetPassword;
    }()
  }, {
    key: "updatePassword",
    value: function () {
      var _updatePassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return http.post("/auth/update-password", payload);

              case 2:
                result = _context15.sent;
                return _context15.abrupt("return", result.data);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function updatePassword(_x19) {
        return _updatePassword.apply(this, arguments);
      }

      return updatePassword;
    }()
  }, {
    key: "whoAmI",
    value: function () {
      var _whoAmI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var result;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return http.get("/auth/whoami");

              case 2:
                result = _context16.sent;
                return _context16.abrupt("return", result.data);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function whoAmI() {
        return _whoAmI.apply(this, arguments);
      }

      return whoAmI;
    }()
  }, {
    key: "generateCannySSO",
    value: function () {
      var _generateCannySSO = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var result;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return http.post("/auth/cannySSO");

              case 2:
                result = _context17.sent;
                return _context17.abrupt("return", result.data);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function generateCannySSO() {
        return _generateCannySSO.apply(this, arguments);
      }

      return generateCannySSO;
    }()
  }, {
    key: "updateUserPassword",
    value: function () {
      var _updateUserPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(id, payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return http.put("/user/".concat(id, "/update-password"), payload);

              case 2:
                result = _context18.sent;
                return _context18.abrupt("return", result.data);

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function updateUserPassword(_x20, _x21) {
        return _updateUserPassword.apply(this, arguments);
      }

      return updateUserPassword;
    }()
  }, {
    key: "getUserConsent",
    value: function () {
      var _getUserConsent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(id) {
        var result;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return http.get("/user/".concat(id, "/consent"));

              case 2:
                result = _context19.sent;
                return _context19.abrupt("return", result.data);

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function getUserConsent(_x22) {
        return _getUserConsent.apply(this, arguments);
      }

      return getUserConsent;
    }()
  }, {
    key: "removeUserAvatar",
    value: function () {
      var _removeUserAvatar = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(imageUrl) {
        var result;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return http.post("/storage/removeProfileAvatar", {
                  imageUrl: imageUrl
                });

              case 2:
                result = _context20.sent;
                return _context20.abrupt("return", result.data);

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      function removeUserAvatar(_x23) {
        return _removeUserAvatar.apply(this, arguments);
      }

      return removeUserAvatar;
    }()
  }]);

  return AuthService;
}();

var authService = new AuthService();
export default authService;